import { Button, Dialog, Divider, TextField,CircularProgress } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import ActionsContextV2 from "../ActionsContextV2";
import ActionOneTimeDeviationCompletedV2 from './ActionOneTimeDeviationCompletedV2';



const TextFieldContainer = styled.div`
  width: 100%;
`;


const TitleContainer = styled.div`
width:100%;
color: white;
font-family: Roboto;
font-size: 20px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;
padding:20px;
height:80px;
background-color:RGB(48, 74, 87);
display:flex;
align-items:center;
`

const ContentContainer = styled.div`
 
  overflow-y:auto;

`

const DeviationContent = styled.div`
padding-left:20px;
padding-right:20px;
padding-top:20px;
`;

const ButtonsContainer = styled.div`
display:flex;
width:100%;
align-items:center;
justify-content:flex-end;
height:80px;
padding-right:20px;
`

const ButtonContainer = styled.div`
width:90px;
margin-left:20px;
`

const Title = styled.div`

`;

const Container = styled.div`

width:760px;
display:flex;
flex-direction:column;
align-items:space-between;
 
`;

const FilesContainer = styled.div`
    display:none;
`

const FileButtonContainer = styled.div`
    padding-top:20px;
    display:flex;
    align-items:center;
`

const DeleteButtonContainer = styled.div`
    padding-left:20px;
`

const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 15px;
font-weight: 500;
`
const CircularProgressContainer = styled.div`
display:flex;
align-items:center;
justify-content:center;
height:200px;
width:100%;
`

const DeviationAction = styled.div`
font-family: Roboto;
font-size: 15px;
padding-top:30px;
padding-left:30px;
padding-bottom:30px;

`


const Subheader = styled.div`
height:50px;
display:flex;
background-color:#ECF5F9;
padding-left:20px;
padding-right:20px;
align-items:center;
justify-content:space-between;
font-family: Roboto;
font-size: 17px;
font-weight: 500;
`

const ModifiedProcedureContainer = styled.div`
padding-top:20px;

width:100%
`;

const ModifiedProcedureSdnTitle = styled.div`
display:grid;
grid-template-columns:1fr 20px 1.5fr
width:100%;
`;

const ActionFileUploadContainer = styled.div`
  padding-top:20px;
  display:grid;
  grid-template-columns:1fr 1fr;
  width:100%;
`



class ActionDeviationDialogV2 extends React.Component {
  static contextType = ActionsContextV2;



  constructor(props){

    super(props);


    const deviationAction = props.context.deviationAction ? props.context.deviationAction : {};
    
    const { 
      deviationReasoning,
      deviationComments,
      modifiedProcedureSdn,
      modifiedProcedureTitle,
      modifiedProcedureUrl,
      isDeviating = true,
      deviationInProgress
    
    } = deviationAction;

    this.state = {
      deviationReasoning : '' ,
      sdn : '' ,
      title : ''  ,
      url : '',
      showCompletion : false,
      saving : false

    }

  }



  renderDeviationModifiedProcedureContent() {

    return(
      <ModifiedProcedureContainer>
              <TextFieldLabel>
        Revised Procedure (Optional)
      </TextFieldLabel>
      <ModifiedProcedureSdnTitle>
        <TextField label="SDN" value={this.state.sdn} onChange={event => this.setState({sdn:event.target.value})} fullWidth margin="normal" variant="outlined" />
        <div/>
        <TextField label="Title" value={this.state.title} onChange={event => this.setState({title:event.target.value})} fullWidth margin="normal" variant="outlined" />
      </ModifiedProcedureSdnTitle>
      <TextField label="Url" value={this.state.url} onChange={event => this.setState({url:event.target.value})} fullWidth margin="normal" variant="outlined" />
      </ModifiedProcedureContainer>
    );
  }
  
  renderDeviationContent()
  {
    const tempDeviationFiles = (this.context.deviationAction && this.context.actionsRedux.tempDeviationFiles[this.context.deviationAction.procedureId]) ? this.context.actionsRedux.tempDeviationFiles[this.context.deviationAction.procedureId] : [];

    return (
    <DeviationContent>
    
      <TextFieldLabel>
        Reason for deviation (Required)
      </TextFieldLabel>
      <TextFieldContainer>
        <TextField placeholder="Start typing..." value={this.state.deviationReasoning} onChange={event => this.setState({deviationReasoning:event.target.value})} multiline fullWidth margin="normal" variant="outlined" />
      </TextFieldContainer>
      {this.renderDeviationModifiedProcedureContent()}
  

    </DeviationContent>);
  }




  renderButtons()
  {

    
    return(
      <ButtonsContainer>
        <ButtonContainer>
          <Button
           disabled={this.state.saving}
           fullWidth
            variant="outlined"
            color="primary"
            onClick={() => {

              this.context.closeOneTimeDeviationDialog();
            }}
          >
            {this.state.showCompletion ? 'Close' : 'Cancel'}
          </Button>
          </ButtonContainer>
          {!this.state.showCompletion &&
          <ButtonContainer>
          <Button 
            disabled={this.state.saving}
            fullWidth
            style={{paddingLeft:10}}
            variant="contained"
            color="primary"
            disabled={!this.state.deviationReasoning}
            onClick={() => {

                this.setState({saving:true});
                const completion = success => {

                  if(success) {
                    this.setState({
                      showCompletion : true,
                      saving : false
                    });
                  } else {
                    this.setState({
                      showCompletion : false,
                      saving : false
                    });
                  }
                }

                this.context.oneTimeDeviation({deviationFromProcedureId:this.props.context.deviationAction.procedureId,deviationInfo:{...this.state}},completion )
             
                

              }}
            >Save</Button>
            </ButtonContainer>
          }
        </ButtonsContainer>

    )
  }

  renderNormalState()
  {
    return(
      <>
      <Subheader>You are deviating from</Subheader>
      <DeviationAction>
          {`${this.context.deviationAction.procedureSdn}-${this.context.deviationAction.procedureName}`}
      </DeviationAction>
      <Subheader>Provide a reason for deviating:</Subheader>
      {this.renderDeviationContent()} 
      </>
    )
  }

  render() {




    return (
      <>
      {this.context.oneTimeDeviationDialogOpen &&
      <Dialog maxWidth='xl' open={true}> 
                       <Container >


        <TitleContainer><Title>One-Time Deviation Request</Title></TitleContainer>
 
        <ContentContainer style={{height:window.innerHeight - 300}}>


        {(!this.state.saving && !this.state.showCompletion) && this.renderNormalState() }
        
        
        {this.state.saving  && <CircularProgressContainer> <CircularProgress/></CircularProgressContainer> }
        {(!this.state.saving && this.state.showCompletion) &&  <ActionOneTimeDeviationCompletedV2/>}

        </ContentContainer>

        

        </Container>
        <Divider/>
        {this.renderButtons()}
      </Dialog>
      }
      </>
    );
  }
}

export default ActionDeviationDialogV2;
